<template>
  <section>
    <h1>General Terms of Sale</h1>
    <hr class="h1-underline"/>
    <div class="content" v-if="productBrand == 'Mitrex'">
      <ul>
        <li>
          Mitrex will be retained for its supply and installation services 
          (if applicable) upon the execution of a purchase order, payment of 
          deposit fee and execution of an agreement to formalize the type and 
          quantity of products requested, scope of work (i.e. supply of material 
          and installation (if applicable)), delivery standard, price, 
          and terms of payment.
        </li>
        <li>
          This Quotation shall be attached as a schedule to the supply and 
          installation agreement. 
        </li>
        <li>
          Mitrex will commence work to fulfill Purchase Orders upon receipt of 
          a non-refundable Deposit Payment from the Customer, and upon 
          execution of the corresponding supply and installation agreement. 
        </li>
        <li>
          Due to material limitations, some panels/ details may require 
          added joints and/ or detail modifications.
        </li>
        <li>
          Product manufacturing processes of material will follow Mitrex’s 
          standard detailing, depth system requirements, specifications, and 
          product fabrication procedures. System details available on request.
        </li>
        <li>
          The returns, refunds, and replacement of Products are covered under 
          Mitrex’s standard 25-year Limited Product Warranty and 25 year 
          Limited Performance Warranty, along with the process of claiming 
          said returns, refunds and replacement. Said warranties are provided 
          upon the execution of the supply and installation agreement..
        </li>
        <li>
          The Products will be delivered by Mitrex to the customer to the 
          location indicated in the Purchase Order. Mitrex reserves the right 
          to schedule the delivery of any order it accepts from the customer, 
          and Mitrex reserves the right to re-schedule at its discretion. 
          Advance notice shall be provided to the customer if there are any 
          changes to the scheduled delivery date.
        </li>
        <li>
          All prices provided in this Quotation are strictly estimates and are 
          subject to change in accordance with Purchase Orders, Change Orders, 
          Purchase Invoices, the supply and installation agreement and further 
          discussions/negotiations between Mitrex and the customer.
        </li>
        <li>
          The Product is supplied on a consignment basis and Mitrex maintains 
          full ownership of the Product until fully paid for by the customer to Mitrex.
        </li>
        <li>
          The total price for supply of Products and related services shall 
          be subject to taxes and any change orders/extras.
        </li>
        <li>
          Products except where otherwise noted will be furnished according to 
          MRTS (Mitrex technical specification). Mitrex panels with Natural Stone 
          Facing are subject to variations in color, markings and texture. 
          Any samples are approximation only. Samples to be agreed by 
          both parties prior to order.
        </li>
        <li>
          Imperfections are to be corrected using Mitrex Technical Specification 
          (MRTS).
        </li>
        <li>
          Any amount payable by the customer to Mitrex that is not paid within 
          the time set out in the provided payment schedule shall accrue daily 
          interest equal to the Prime Rate plus twenty percent (20%) per annum 
          commencing on the date on which such amount was due and ending the 
          date on which such amount has been paid in full, such interest to be 
          compounded monthly and payable on demand.
        </li>
        <li>
          The Customer must inspect the Products supplied by Mitrex immediately 
          upon receipt of same. Defects reported from such inspection might only 
          be claimed prior to any use and/or installation of the Product; 
          thereafter, Mitrex shall not be responsible for any defects to any 
          Product. Mitrex shall investigate and either repair or replace 
          Products as necessary, in accordance with its limited warranties.
        </li>
        <li>
          All drawings, catalogues, technical literature or information of any 
          kind in any form sent to the customer is strictly confidential and 
          remains the sole and exclusive property of Mitrex Inc. The customer 
          shall not copy, reproduce, transmit or distribute any such information 
          to third parties without obtaining prior written consent from Mitrex.
        </li>
        <li>
          Mitrex Inc. will not be responsible for delays in delivery, 
          installation, or any related services due to any unforeseen impediments 
          beyond its control, such as disruptive weather, Acts of Gods, strikes, 
          boycotts, lockouts, fires, war, pandemics, embargos, or 
          manufacturing and operational delays. 
        </li>
        <li>
          All work will be performed during regular business hours with Non-Union forces.
        </li>
        <li>
          Mitrex will require unfettered use of the customer’s onsite power and/or 
          utilities for tools and equipment for installations, repairs, 
          replacements, or any other related services pursuant to the supply 
          and installation agreement.
        </li>
        <li>
          The customer shall provide firm, level, clear and free access to 
          all work areas for the safe installation of its Product at the 
          customer’s designated location.
        </li>
        <li>
          The schedule for supply and installation of work may be mutually agreed 
          upon by the Client and Mitrex.
        </li>
        <li>
          Wall substrate to be plumb, true and acceptable to standard 
          construction tolerances prior to installation of exterior wall panels. 
          Extra cost may apply for excessive wall adjustments.
        </li>
        <li>
          All additional work performed, or Products supplied outside the scope 
          of work outlined in the Purchase Order and/or supply and installation 
          agreement will require the execution of a change order for the additional 
          supply of Product and/or services outlining the modified and/or extended 
          scope of work (the “Change Order/Extra Sheet”). Mitrex will furnish the 
          customer with a Change Order/Extra Sheet accordingly and its costs will 
          be added onto the total Price payable by the customer.
        </li>
      </ul>
    </div>

    <div 
      class="content" 
      :class="{ 'tight-list': fitPage }" 
      v-if="productBrand == 'Cladify'">
      <ul>
        <li>An agreement to be concluded between Cladify and the customer at the earliest of issuing an order confirmation by Cladify.</li>
        <li>Deposit payment is required. No project shall commence until the deposit has been made and contract has been confirmed.</li>
        <li>Our proposal is based on a 15% retainer.</li>
        <li>Price based on non-union labour.</li>
        <li>Payments to Cladify are not contingent upon Contractor or Owner being paid by Owner and/or Lender. No contingency of paying will be acceptable.&nbsp;</li>
        <li>Proposal subject to a mutually agreeable contract between Cladify and the Owner and/or General Contractor.&nbsp;</li>
        <li>Our proposal is based on the responsibility for the protection of our material after acceptance to be borne by the owner and/or General Contractor.&nbsp;</li>
        <li>Quote valid for 30 days.</li>
        <li>Proposal is based on sqft area, any addition on the estimated area will result in price being re-estimated.&nbsp;</li>
        <li>Tower crane &amp; material hoist supplied by G.C. free of charge for unloading trucks &amp; loading floors with crates.</li>
        <li>Overall R-values, condensation values, and all other performance criteria to be determine by final design. At this point, Cladify has not considered thermal and structural requirements that can affect the pricing.&nbsp;</li>
        <li>Shop drawings and other related documents to be submitted in English.</li>
        <li>Due to material limitations, some panels/ details may require added joints and/ or detail modifications.</li>
        <li>Quoted system to follow Cladify standard detailing, depth system requirements, specifications and product fabrication procedures. System details available on request.</li>
        <li>No return, exchange or refund policy applies to all custom-made products.</li>
        <li>Schedule to be determined.</li>
        <li>All estimates are subject to site delivery and final invoice is based on total delivered products.</li>
        <li>All delivered products are the property of Cladify Inc. until fully paid by the customer.</li>
        <li>The price stated in the order shall be the base price for the products and does not include value added taxes. And all amount to be paid in full and without any deduction.</li>
        <li>Products except where otherwise noted will be furnished according to CTS (Cladify Technical Specification).</li>
        <li>Cladify panels with Natural Stone Facing are subject to variations in color, markings and texture. Any samples are approximation only. Samples to be agreed by both parties prior to order.</li>
        <li>Imperfections are to be corrected using Cladify Technical Specification (CTS).</li>
        <li>Unless otherwise agreed in writing, any invoice shall be due and payable within 45 calendar days of the date of such invoice.</li>
        <li>2% per month (24% per annum) charged on overdue accounts, this rate will apply both before and after any adjustment that may be obtained for a nonpayment.</li>
        <li>Upon product arrival, it&rsquo;s up to the customer to inspect their condition, nature and their compliance with the order and inform Cladify company any compliance in writing within 3 days of receipt of the products. Cladify warrants to re-supply such defective material only as brought to their attention; material placed on the wall shall constitute product acceptance.</li>
        <li>Any drawing, catalogue or technical literature sent to the customer before and after termination of order remains Cladify Inc. exclusive property and cannot be copied, reproduced, transmitted or notified to third parties without prior consent in writing from Cladify, as strictly confidential.</li>
        <li>Cladify company cannot be responsible for delays due to any causes unforeseen impediments beyond his control, like strikes, boycotts, lockouts, fires, war, embargos and delay in receiving of raw material.</li>
        <li>Schedule of work to be mutually agreed upon by the Client and Cladify Inc.</li>
        <li>Wall substrate to be plumb, true and acceptable to standard construction tolerances prior to installation of exterior wall panels. Extra cost may apply for excessive wall adjustments.</li>
        <li>No liquidated or Consequential damages.</li>
        <li>No waivers of Subrogation or Severability of Interest clauses.</li>
        <li>Schedule will be weather permitting and no Penalties for slow previous trades.</li>
        <li>Upon Acceptance, this quotation is or becomes part of the legal contract documents.</li>
        <li>Changes to the scope of work to be priced on an item by item basis or completed on a time and material basis.</li>
        <li>No extra work will be performed without written instruction from the Construction Manager.</li>
        <li>All extra to contract hours performed must be signed off by an authorized owner Representative.</li>
        <li>All approved extra to contract time and material charges will be billed on the next billing</li>
      </ul>
    </div>

    <signature-line 
      :class="{ 'mt-3': productBrand == 'Mitrex' }"
      v-if="hasSignatureLine" 
      section-name="General Terms of Sale"
      has-date/>

  </section>
</template>

<script>
import SignatureLine from '@/components/proposalmaker/SignatureLine'

export default {
  props: {
    productBrand: {
      type: String,
      required: true
    },
    hasSignatureLine: {
      type: Boolean,
      default: true
    },
    fitPage: {
      type: Boolean,
      default: true
    }
  },
  components: { SignatureLine }
}
</script>

<style scoped lang="scss">

.tight-list {
  ul {
    line-height: 1.2;
    margin-left: 1.15em;
    font-size: 0.72em;
    li {
      margin-top: 0em;
    }
  }
}
</style>
